import * as React from "react";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { rxRoute } from "../../helpers/formatting";
import SectionLoadingError from '../common/SectionLoadingError';
import { connect } from "react-redux";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

class ReadyForPickup extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.ReadyForPickup.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { readyForPickup, defaultStoreNumber, currentPharmacyUser } = this.props;        
        var proxyUser = (currentPharmacyUser && currentPharmacyUser.firstName) ? currentPharmacyUser.firstName + ' has' : 'You have';

        return (
            !readyForPickup ? null :
                readyForPickup.length === 0 ? <div className="col-12"><SectionLoadingError message={proxyUser + " no prescriptions ready for pick up."} sectionErrorClass="no-results-error" /></div>
                : readyForPickup.sort((rx1, rx2) => {
                if (rx1.storeNumber === defaultStoreNumber) {
                    if (rx2.storeNumber !== defaultStoreNumber) {
                        return -1;
                    }
                }
                else if (rx2.storeNumber === defaultStoreNumber) {
                    return 1;
                }
                const name1 = rx1.rxDrugName.toUpperCase();
                const name2 = rx2.rxDrugName.toUpperCase();
                return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
            }).map((item, index) => (
                <div className="col-12 list-item-col" key={index}>
                    <div className="row">
                        <div className="col-12 col-sm-4">
                            {item.rxDrugName}<br />
                            <span className="rx-num">Rx No. {item.rxNumber}</span>
                        </div>
                        <div className="col-12 col-sm-4">{item.storeNumber === defaultStoreNumber ? 'Your Pharmacy' : item.pharmacyName}</div>
                        <div className="col-12 col-sm-4">Estimated Cost:{' '}
                            <span className="rx-cost">
                                <NumberFormat value={item.patientPay} displayType={'text'} thousandSeparator
                                    decimalScale={2} fixedDecimalScale prefix={'$'}
                                />
                            </span>
                        </div>
                    </div>
                    <Link className="list-item-block-link" aria-label={"View " + item.rxDrugName + " pickup details"} to={{ pathname: `${rxRoute('pickupDetails')}/${item.storeNumber}` }}><span /></Link>
                </div>
            ))
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu)
    };
};

export default connect(mapStateToProps)(ReadyForPickup);